import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Tooltip } from 'react-tippy'

class InfoButton extends Component {
  static propTypes = {
    content: PropTypes.string.isRequired,
    styles: PropTypes.any,
    iconClass: PropTypes.string,
  }
  static defaultProps = {
    iconClass: 'fal fa-info-circle',
  }

  render() {
    const { content, styles, iconClass } = this.props
    return (
      <Tooltip title={content} sticky arrow trigger="click" distance={5}>
        <i style={{ ...styles }} className={`info-button ${iconClass}`} />
      </Tooltip>
    )
  }
}

export default InfoButton



// WEBPACK FOOTER //
// ./src/components/ui/buttons/InfoButton.js